import { z } from 'zod';

/**
 * A skill whose runs have settled into one repeated shape (IMM-436.9).
 *
 * The point of the advisory: once a skill does the same thing the same way
 * twenty times a month, paying a model to decide it again each time is waste.
 * Everything here is evidence for that judgement — the operator makes the call.
 */
export const CodificationCandidateSchema = z.object({
  skillInstanceId: z.uuid(),
  workspaceId: z.uuid(),
  definitionKey: z.string().min(1),
  definitionName: z.string().min(1),
  /** Completed, fingerprinted runs in the window. */
  runCount: z.number().int(),
  /** How many of those shared the dominant fingerprint. */
  dominantRunCount: z.number().int(),
  /** `dominantRunCount / runCount`, 0–1. */
  dominance: z.number(),
  /** The repeated shape, in order — reconstructed from a run bearing it. */
  toolSequence: z.array(z.string()),
  /**
   * `dominantRunCount × avgCostPerRun` over the window. Advisory only: it is
   * what those runs cost, not a bill and not a promise about what codifying
   * would save.
   */
  projectedSaving: z.number(),
});

export type CodificationCandidate = z.infer<typeof CodificationCandidateSchema>;

export const ListCodificationCandidatesResponseSchema = z.object({
  data: z.array(CodificationCandidateSchema),
});

export type ListCodificationCandidatesResponse = z.infer<typeof ListCodificationCandidatesResponseSchema>;
